/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/SystemListItems.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for System List Items
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    SYSTEMLISTITEM_LIST_CONTAINER_LOADED,
    SYSTEMLISTITEM_LIST_CONTAINER_UNLOADED,
    SYSTEMLISTITEM_LIST_TABLE_LOADED,
    SYSTEMLISTITEM_LIST_TABLE_UNLOADED,
    SYSTEMLISTITEM_SELECT_ROW,
    SYSTEMLISTITEM_ADD,
    SYSTEMLISTITEM_EDIT,
    SYSTEMLISTITEM_DELETE,
    SYSTEMLISTITEM_DELETE_DISABLE,
    SYSTEMLISTITEM_OPEN_WARNING,
    SYSTEMLISTITEM_CLOSE_WARNING,
    SYSTEMLISTITEM_EDIT_CONTAINER_LOADED,
    SYSTEMLISTITEM_EDIT_CONTAINER_UNLOADED,
    SYSTEMLISTITEM_EDIT_FORM_LOADED,
    SYSTEMLISTITEM_EDIT_FORM_UNLOADED,
    SYSTEMLISTITEM_EDIT_DATA_LOAD,
    SYSTEMLISTITEM_EDIT_CONTAINER_SUBMIT,
    SYSTEMLISTITEM_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeSystemListItems';

const defaultState = {
    refreshList: false,
    danger: false,
    systemlistitemid: 0,
    listid: 0,
    listname: '',
    listdescription: '',
    parentid: 0,
    datatypeid: 0,
    name: '',
    description: '',
    integervalue: 0,
    doublevalue: 0.00,
    datetimevalue: '1000-01-01',
    stringvalue: '',
    color: '',
    icon: '',
    orderid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SYSTEMLISTITEM_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                systemlistitems: action.payload[0] ? action.payload[0].records : [],
                listname: action.payload[1] ? action.payload[1].name : '',
                listdescription: action.payload[1] ? action.payload[1].description : '',
                itempath: action.payload[2] ? action.payload[2].records : []
            }
        case SYSTEMLISTITEM_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case SYSTEMLISTITEM_SELECT_ROW:
            return {
                ...state,
                systemlistitemid: action.id
            }
        case SYSTEMLISTITEM_ADD:
            return {
                ...state
            }
        case SYSTEMLISTITEM_EDIT:
            return {
                ...state,
                systemlistitemid: action.id
            }
        case SYSTEMLISTITEM_DELETE:
            return {
                ...state,
                systemlistitemid: null
            }
        case SYSTEMLISTITEM_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case SYSTEMLISTITEM_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case SYSTEMLISTITEM_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case SYSTEMLISTITEM_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                systemlistitemid: action.payload[0] ? action.payload[0].systemlistitemid : 0,
                listid: action.payload[0] ? action.payload[0].listid : 0,
                parentid: action.payload[0] ? action.payload[0].parentid : 0,
                datatypeid: action.payload[0] ? action.payload[0].datatypeid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                value: action.payload[0] ? action.payload[0].value : '',
                color: action.payload[0] ? action.payload[0].color : '',
                icon: action.payload[0] ? action.payload[0].icon : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : '',
                listname: action.payload[1] ? action.payload[1].name : '',
                listdescription: action.payload[1] ? action.payload[1].description : '',
                datatypes: action.payload[2] ? action.payload[2].records : []
            }
        case SYSTEMLISTITEM_EDIT_DATA_LOAD:
            return {
                ...state,
                systemlistitemid: action.payload ? action.payload.systemlistitemid : 0,
                listid: action.payload ? action.payload.listid : 0,
                parentid: action.payload ? action.payload.parentid : 0,
                datatypeid: action.payload ? action.payload.datatypeid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                value: action.payload ? action.payload.value : '',
                color: action.payload ? action.payload.color : '',
                icon: action.payload ? action.payload.icon : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case SYSTEMLISTITEM_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case SYSTEMLISTITEM_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case SYSTEMLISTITEM_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case SYSTEMLISTITEM_LIST_CONTAINER_UNLOADED:
        case SYSTEMLISTITEM_LIST_TABLE_UNLOADED:
        case SYSTEMLISTITEM_EDIT_CONTAINER_UNLOADED:
        case SYSTEMLISTITEM_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/SystemListItems.js